import {
  PersonAvatar,
  TeamIcon,
} from '@/shared/components/people-team-list/PeopleTeamAvatars';
import { PersonAvatarTooltip } from '@/shared/components/people-team-list/PersonAvatarTooltip';
import { TooltipProvider } from '@/shared/components/ui/Tooltip';

export const MAX_VISIBLE_AVATARS = 4;

export interface AvatarItem {
  type: 'user' | 'team';
  id: string;
  name: string;
  initials: string;
  imageUrl?: string;
  role?: string;
}

export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  return `${parts[0]?.[0] ?? ''}${parts[1]?.[0] ?? ''}`.toUpperCase();
}

export function AvatarStack({
  items,
  totalCount,
}: {
  items: AvatarItem[];
  totalCount: number;
}) {
  const visible = items.slice(0, MAX_VISIBLE_AVATARS);
  const remaining = totalCount - visible.length;

  return (
    <TooltipProvider delayDuration={300}>
      <div className="flex items-center">
        {visible.map((item, index) => {
          const avatarEl = (
            <div
              className="flex-shrink-0 rounded-full border-2 border-muted/30"
              style={{
                marginInlineStart: index === 0 ? 0 : -6,
                zIndex: visible.length - index,
              }}
            >
              {item.type === 'user' ? (
                <PersonAvatar
                  initials={item.initials}
                  imageUrl={item.imageUrl}
                />
              ) : (
                <TeamIcon />
              )}
            </div>
          );

          return item.type === 'user' ? (
            <PersonAvatarTooltip
              key={`${item.type}-${item.id}`}
              name={item.name}
              initials={item.initials}
              imageUrl={item.imageUrl}
              role={item.role}
            >
              {avatarEl}
            </PersonAvatarTooltip>
          ) : (
            <div key={`${item.type}-${item.id}`}>{avatarEl}</div>
          );
        })}
        {remaining > 0 && (
          <span
            className="flex h-[22px] w-[22px] flex-shrink-0 items-center justify-center rounded-full border-2 border-muted/30 bg-[#e5e7eb] text-[9px] font-semibold text-muted-foreground"
            style={{ marginInlineStart: -6 }}
          >
            +{remaining}
          </span>
        )}
      </div>
    </TooltipProvider>
  );
}
